document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('predictive-search-component').forEach((component) => {
    const dialog = component.closest('dialog-component');
    if (!dialog) return;

    dialog.addEventListener('dialog:open', () => {
      const results = component.querySelector('#predictive-search-results');
      if (results) results.innerHTML = '';
    });
  });
});